<template>
	<div id="TopMenu">

		<!-- <el-button-group>
			<el-button type="primary" class="top-menu-item" style="background-color:#3377ff;"
				v-for="(item, index) in topMenuData" :key="index" @click="handleSelect(index)">{{ item.title
				}}</el-button>
		</el-button-group> -->


	</div>
</template>


<script>
import { mapGetters, mapActions } from 'vuex'
import { rolesToMenu } from '@/utils/rolesToMenu'
export default {
	name: 'TopMenu',
	computed: {
		...mapGetters([
			'sysDic',
			'state',
			'state_name',
			'county',
			'county_name',
			'town',
			'town_name',
			'tableLoading',
			'perms',
			'roles'
		])
	},
	data: function () {
		return {
			activeIndex: '1',
			topMenuData: [
			]
		}
	},
	created () {
		// this.handleSelect({ index: 1 })
		this.topMenuData = rolesToMenu(this.roles)
		this.setMenu2(this.topMenuData)
	},
	methods: {
		...mapActions([
			'setMenu2'
		]),
		handleSelect (index) {
			const el = document.getElementsByClassName('top-menu-item')
			for (let i = 0; i < el.length; i++) {

				el[i].style.backgroundColor = '#2174e1'
			}
			el[index].style.backgroundColor = '#409eff'
			// this.setMenu2(this.topMenuData[index]['children'])
		}
	},
	// 侦听器
	watch: {

	}
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.title2 {
	font-size: 20px;
	height: 100%;
	padding-left: 20px;

	line-height: 250%;

	font-weight: bold;
	color: #fff;
	letter-spacing: 3px;
}

.top-menu-item {
	height: 46px;
	background-color: #3377ff;
	border-top-width: 0px;
	border-bottom-width: 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/topMenu/index.vue